<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">

        <!--<UpdateObjects v-bind:order_data="order_data" v-bind:session_data="session_data"></UpdateObjects>-->
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-12">

                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Select your On Market Data</div>

                    <div class="app_border layout__overflow-hidden">
                        <v-card flat>
                            <v-container>
                                <v-row>
                                    <v-col class="data-column">
                                        <v-container class="data-container">
                                            <div class="text__size-22 text__colour-grey text__style-bold layout__display-inline-block layout__position-top">
                                                Search by:&nbsp;
                                            </div>

                                            <v-toolbar class="data-tabs layout__display-inline-block" flat>
                                                <template>
                                                    <v-tabs v-model="tabs">
                                                        <v-tooltip top max-width="500px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-tab v-bind="attrs" v-on="on">
                                                                    Location
                                                                </v-tab>
                                                            </template>
                                                            <span>Search using a specific location by entering an town or postcode below.</span>
                                                        </v-tooltip>

                                                        <v-tooltip top max-width="500px">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-tab v-bind="attrs" v-on="on">
                                                                    Radius
                                                                </v-tab>
                                                            </template>
                                                            <span>Drop a pin on the map and search within a defined radius. You're able to increase or decrease the search area by choosing from the dropdown menu below.</span>
                                                        </v-tooltip>
                                                    </v-tabs>
                                                </template>
                                            </v-toolbar>

                                            <v-tabs-items class="data-tab-items layout__margin__top-30" v-model="tabs">
                                                <v-tab-item>
                                                    <v-card flat>
                                                        <div class="text__size-20 text__colour-grey text__style-bold">
                                                            I want to reach households on market near
                                                        </div>

                                                        <v-row class="height-60px">
                                                            <v-col cols="12" sm="12">
                                                                <el-input autofocus v-model="currentPlace" class="inline-block search-field-otm" id="searchTextField" placeholder="Enter town or postcode">
                                                                </el-input>

                                                                <span>
                                                                    <v-btn class="custom-btn search-btn inline-block" :ripple="false" tile light small depressed @click="addCircleToMapFromText()">
                                                                        Search
                                                                    </v-btn>
                                                                </span>

                                                                <v-select class="radius_dropdown"
                                                                        v-model="location.radius"
                                                                        :items="radius_choices_location"
                                                                        item-text="text"
                                                                        item-value="value"
                                                                        label=""
                                                                        :menu-props="{contentClass: 'instant_marketing_dropdown_menu'}"
                                                                        @change="radiusSelected()"
                                                                ></v-select>

                                                                <v-btn class="custom-btn select-btn-units"
                                                                        :ripple="false"
                                                                        tile small depressed @click="clickDistanceUnit()">{{
                                                                    location.distance_unit }}
                                                                </v-btn>

                                                                <v-row class="radius-row-otm1">
                                                                    <v-col class="radius-col">
                                                                        <span :class="circlelatlng_class_1" class="radius-span text__colour-0000ff" id="radius-span-1">Radius 1
                                                                            <v-icon class="text__size-16-important remove-circle" @click="removeCircle()">mdi-window-close
                                                                            </v-icon>
                                                                        </span>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-tab-item>

                                                <v-tab-item>
                                                    <v-card flat>
                                                        <div class="text__size-14 text__colour-grey text__style-bold">
                                                            I want to reach households in my drawn radius
                                                        </div>

                                                        <div>
                                                            <!--<v-btn class="custom-btn add-pin-btn"
                                                                    :ripple="false"
                                                                    tile dark small depressed
                                                                    @click="addPin()">
                                                                <v-icon class="font-size-18">mdi-plus
                                                                </v-icon>
                                                                Add Pin&nbsp;
                                                            </v-btn>-->

                                                            <v-select class="radius_dropdown"
                                                                    v-model="radius.radius"
                                                                    :items="radius_choices_radius"
                                                                    item-text="text"
                                                                    item-value="value"
                                                                    label=""
                                                                    :menu-props="{contentClass: 'instant_marketing_dropdown_menu'}"
                                                                    @change="radiusSelected()"
                                                            ></v-select>

                                                            <v-btn class="custom-btn select-btn-units"
                                                                    :ripple="false"
                                                                    tile small depressed @click="clickDistanceUnit()">{{
                                                                radius.distance_unit }}
                                                            </v-btn>

                                                            <v-row class="radius-row-otm2">
                                                                <v-col class="radius-col">
                                                                    <span :class="circlelatlng_class_2" class="radius-span text__colour-0000ff" id="radius-span-1">Radius 1
                                                                        <v-icon class="text__size-16-important remove-circle" @click="removeCircle()">mdi-window-close
                                                                        </v-icon>
                                                                    </span>
                                                                </v-col>
                                                            </v-row>

                                                            <v-row class="drawing-div">
                                                                <v-row :class="pin_drawing_class">
                                                                    <span class="drawing">Drawing...</span>
                                                                </v-row>
                                                                <v-row :class="markers_drawing_class">
                                                                    <span class="drawing">Adding property markers...</span>
                                                                </v-row>
                                                                <!--<v-row :class="pinlatlng_class">
                                                                    <span class="pinlatlng">{{ pinlatlng }}<v-icon
                                                                            class="font-size-20 remove-pin"
                                                                            @click="removePin()">mdi-window-close</v-icon></span>
                                                                </v-row>-->
                                                                <v-row :class="circle_drawing_class">
                                                                    <span class="drawing">Drawing...</span>
                                                                </v-row>
                                                                <!--<v-row :class="circlelatlng_class">
                                                                    <span class="circlelatlng">{{ circlelatlng }}<v-icon
                                                                            class="font-size-20 remove-circle"
                                                                            @click="removeCircle()">mdi-window-close</v-icon></span>
                                                                </v-row>-->
                                                            </v-row>
                                                        </div>
                                                    </v-card>
                                                </v-tab-item>
                                            </v-tabs-items>

                                            <div>
                                                <v-card flat>
                                                    <div class="text__size-12 text__colour-grey text__style-bold">
                                                        Use the + icons below to apply your filters and click on the pre-filled boxes to change your criteria
                                                    </div>

                                                    <v-row class="height-120px">
                                                        <div class="layout__display-contents">
                                                            <div class="grey lighten-3 selection-div-otm">
                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-btn class="custom-btn icon-btn" :ripple="false"
                                                                                tile color="grey" dark x-small depressed
                                                                                @click="clickPropertyValueIcon()">
                                                                                <v-icon small>{{ icon_choices[property_value_icon] }}</v-icon>
                                                                            </v-btn>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">that are worth</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-1"
                                                                        :class="property_value_classes_1" :ripple="false"
                                                                        tile small depressed @click="clickPropertyValue1()">
                                                                        {{ property_value_1_choices[property_value_1] }}
                                                                    </v-btn>
                                                                    <v-btn class="custom-btn select-btn-2"
                                                                        :class="property_value_classes_1" :ripple="false"
                                                                        tile small depressed @click="clickPropertyValue2()">
                                                                        {{ property_value_2_choices[property_value_2] }}
                                                                    </v-btn>
                                                                    <span class="custom-text-2"
                                                                        :class="property_value_classes_2"
                                                                        id="property_value_3_text">
                                                                        <span class="vertical-center">and</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-3"
                                                                        :class="property_value_classes_3"
                                                                        id="property_value_3_value" :ripple="false" tile
                                                                        small depressed @click="clickPropertyValue3()">{{
                                                                        property_value_3_choices[property_value_3] }}
                                                                    </v-btn>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-btn class="custom-btn icon-btn" :ripple="false"
                                                                                tile color="grey" dark x-small depressed
                                                                                @click="clickOnMarketDaysIcon()">
                                                                                <v-icon small>{{ icon_choices[on_market_days_icon] }}</v-icon>
                                                                            </v-btn>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">on market for</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-1"
                                                                        :class="on_market_days_classes_1" :ripple="false"
                                                                        tile small depressed @click="clickOnMarketDays1()">
                                                                        {{ on_market_days_1_choices[on_market_days_1] }}
                                                                    </v-btn>
                                                                    <v-btn class="custom-btn select-btn-2"
                                                                        :class="on_market_days_classes_1" :ripple="false"
                                                                        tile small depressed @click="clickOnMarketDays2()">
                                                                        {{ on_market_days_2_choices[on_market_days_2] }}
                                                                    </v-btn>
                                                                    <span class="custom-text-2"
                                                                        :class="on_market_days_classes_2"
                                                                        id="on_market_days_3_text">
                                                                        <span class="vertical-center">and</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn-3"
                                                                        :class="on_market_days_classes_3"
                                                                        id="on_market_days_3_value" :ripple="false" tile
                                                                        small depressed @click="clickOnMarketDays3()">{{
                                                                        on_market_days_3_choices[on_market_days_3] }}
                                                                    </v-btn>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="icon-container">
                                                                        <span class="vertical-center">
                                                                            <v-btn class="custom-btn icon-btn" :ripple="false"
                                                                                tile color="grey" dark x-small depressed
                                                                                @click="clickPropertyTypeIcon()">
                                                                                <v-icon small>{{ icon_choices[property_type_icon] }}</v-icon>
                                                                            </v-btn>
                                                                        </span>
                                                                    </span>
                                                                    <span class="custom-text">
                                                                        <span class="vertical-center">property type</span>
                                                                    </span>
                                                                    <v-btn class="custom-btn select-btn"
                                                                        :class="property_type_classes_1" :ripple="false"
                                                                        tile small depressed
                                                                        @click="clickPropertyType()">{{
                                                                        property_type_choices[property_type] }}
                                                                    </v-btn>
                                                                    <span class="icon-container"
                                                                        :class="property_type_classes_2">
                                                                        <span class="vertical-center">
                                                                            <v-dialog v-model="property_types_dialog"
                                                                                    persistent max-width="600px">
                                                                                <template v-slot:activator="{ on }">
                                                                                    <v-btn class="custom-btn list-btn"
                                                                                        :class="property_type_classes_2"
                                                                                        :ripple="false" tile x-small
                                                                                        depressed v-on="on">
                                                                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <v-card>
                                                                                    <v-card-title>
                                                                                        <span class="headline">Select Property Types</span>
                                                                                    </v-card-title>
                                                                                    <v-card-text>
                                                                                        <v-container>
                                                                                            <v-layout row wrap align-start>
                                                                                                <ul class="nolist">
                                                                                                    <li class="nolist"
                                                                                                        v-for="(e,index) in property_type_choices" :key ="e.id">
                                                                                                        <div v-if="e != 'multiple'">
                                                                                                            <v-checkbox
                                                                                                                    :key="index"
                                                                                                                    v-model="selected_property_types"
                                                                                                                    :value="e"
                                                                                                                    :label="e"
                                                                                                                    :hide-details="e !== (property_type_choices.length - 1)"
                                                                                                            >	
                                                                                                            </v-checkbox>
                                                                                                        </div>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </v-layout>
                                                                                        </v-container>
                                                                                    </v-card-text>
                                                                                    <v-card-actions>
                                                                                        <v-spacer></v-spacer>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="property_types_dialog = false">Close</v-btn>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="property_types_dialog = false">Save</v-btn>
                                                                                    </v-card-actions>
                                                                                </v-card>
                                                                            </v-dialog>
                                                                        </span>
                                                                    </span>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="layout__width-175px"></span>
                                                                    <v-btn class="custom-btn select-btn btn-enabled"
                                                                        tile small depressed
                                                                        @click="clickDisplayStatus()">
                                                                        Market Status
                                                                    </v-btn>
                                                                    <span class="icon-container"
                                                                        :class="display_status_class">
                                                                        <span class="vertical-center">
                                                                            <v-dialog v-model="display_status_dialog"
                                                                                    persistent max-width="600px">
                                                                                <v-card>
                                                                                    <v-card-title>
                                                                                        <span class="headline">Select Market Status</span>
                                                                                    </v-card-title>
                                                                                    <v-card-text>
                                                                                        <v-container>
                                                                                            <v-layout row wrap align-start>
                                                                                                <ul class="nolist">
                                                                                                    <li class="nolist"
                                                                                                        v-for="(e,index) in display_status_choices" :key = "e.id">
                                                                                                        <v-checkbox
                                                                                                                :key="index"
                                                                                                                v-model="selected_display_status_dialog"
                                                                                                                :value="e"
                                                                                                                :label="e"
                                                                                                                :hide-details="e !== (display_status_choices.length - 1)"
                                                                                                        >	
                                                                                                        </v-checkbox>
                                                                                                    </li>
                                                                                                </ul>
                                                                                            </v-layout>
                                                                                        </v-container>
                                                                                    </v-card-text>
                                                                                    <v-card-actions>
                                                                                        <v-spacer></v-spacer>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="closeDisplayStatusChoices()">Close</v-btn>
                                                                                        <v-btn color="blue darken-1" text
                                                                                            @click="saveDisplayStatusChoices()">Save</v-btn>
                                                                                    </v-card-actions>
                                                                                </v-card>
                                                                            </v-dialog>
                                                                        </span>
                                                                    </span>
                                                                </v-row>

                                                                <v-row>
                                                                    <span class="layout__width-175px"></span>
                                                                    <span class="display_status_selected" v-html="selected_display_status_text"></span>
                                                                </v-row>

                                                                <v-row>
                                                                    <v-layout align-end justify-end>
                                                                        <v-btn class="custom-btn apply-btn float-right"
                                                                                :ripple="false" tile color="grey" dark small
                                                                                depressed @click="applyFilters()">
                                                                            Apply
                                                                        </v-btn>
                                                                    </v-layout>
                                                                </v-row>
                                                            </div>
                                                        </div>
                                                    </v-row>
                                                </v-card>
                                            </div>

                                            <div class="count-div height-35px"
                                                    :class="{'flashing':flashing}">
                                                <span class="margin-left-10 line-height-2-2 display-inline-block">Records returned:</span>
                                                <span class="font-size-24 margin-right-10 float-right">{{ record_count }}</span>
                                            </div>
                                        </v-container>
                                    </v-col>

                                    <v-col>
                                        <gmap-map 
                                                id="map"
                                                ref="map"
                                                :center="center"
                                                :zoom="15"
                                                style="width:100%; height: 100%;"
                                                v-on:click="getLocation">
                                            <gmap-marker
                                                    :key="'pin'+index"
                                                    v-for="(m, index) in pins"
                                                    :position="m.position"
                                                    @click="center=m.position"
                                                    :draggable="true"
                                                    @dragend="pinDragged(index,$event.latLng)"
                                            ></gmap-marker>
                                            <gmap-marker
                                                    :key="'marker'+index"
                                                    v-for="(m, index) in markers_array"
                                                    :position="m.position"
                                                    :clickable="false"
                                                    :draggable="false"
                                                    :icon="m.markerOptions"
                                            ></gmap-marker>
                                            <GmapCircle
                                                    id="circle"
                                                    ref="circle"
                                                    v-for="(pin, index) in circles"
                                                    :key="'circle'+index"
                                                    :center="center"
                                                    :radius="distance"
                                                    :options="{clickable: false, draggable: true, editable: true, fillColor: area_colour, fillOpacity: 0.25, strokeColor: area_colour, strokeOpacity: 0.5, strokeWeight: 2}"
                                                    @click="center=m.position"
                                                    @radius_changed="radiusChanged" 
                                                    @center_changed="centerChanged"
                                            ></GmapCircle>
                                        </gmap-map>

                                        <div class="text__size-16 text__colour-grey text__style-bold">
                                            Use the white markers to move and adjust the size of your radius
                                        </div>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <div class="layout__padding__top-20px">
                                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                                    v-on:click="navigate('fulfilment');">Back
                                            </el-button>

                                            <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right"
                                                    v-on:click="previewData()">Preview your data
                                            </el-button>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>

                        <!--<v-dialog v-model="dialog" width="500">
                            <v-card>
                                <v-card-title class="headline grey lighten-2" primary-title></v-card-title>

                                <v-card-text>
                                    Please enter a search term, apply filters, or define a map area to view a data
                                    record count.
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" text @click="dialog = false">
                                        Ok
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>-->

                        <v-snackbar v-model="dialog" color="info" :top="true" :timeout="5000" :vertical="vertical">
                            Please enter a search term, apply filters, or <br>define a map area to view a data record count.
                            <v-btn dark text color="yellow" @click="dialog = false">
                                Close
                            </v-btn>
                        </v-snackbar>

                        <v-snackbar v-model="maximumRadiusMessage" color="info" :top="true" :timeout="5000">
                            Sorry the maximum radius is 10km.
                            <v-btn dark text @click="maximumRadiusMessage = false">
                                Close
                            </v-btn>
                        </v-snackbar>

                        <v-overlay :value="loading">
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import qs from 'qs';
    import {axios} from '@/mixins/Axios.js';
    import {gmapApi} from 'vue2-google-maps';

    export default {
        name: "GoogleMap",
        data() {
            return {
                connection_params: {},
                data_url: '',
                dataProvider: 'Leadhub',
                query_string: '',
                order: {},
                center: {
                    lat: 0,
                    lng: 0
                },
                pins: [],
                circles: [],
                circle1_selected: false,
                circle2_selected: false,
                places: [],
                markers_array: [],
                location: {
                    center: {
                        lat: 0,
                        lng: 0
                    },
                    circles: [],
                    radius: { 'text': '5km', 'value': '5' },
                    distance_unit: 'km',
                    distance: 5000,
                },
                radius: {
                    center: {
                        lat: 0,
                        lng: 0
                    },
                    circles: [],
                    radius: { 'text': '5km', 'value': '5' },
                    distance_unit: 'km',
                    distance: 5000,
                },
                tabs: null,
                tab_selected: '',
                dialog: false,
                addingPin: false,
                addingCircle: false,
                addingMarkers: false,
                add_pin_disabled: false,
                add_circle_disabled: false,
                maximumRadiusMessage: false,
                loading: false,
                //distance_unit_1: 'km',
                //distance_unit_2: 'km',
                //radius1_selected: { 'text': '5km', 'value': '5' },
                //radius2_selected: { 'text': '5km', 'value': '5' },
                distance: 100,
                area_colour: null,
                radius_count: 0,
                currentPlace: '',
                pinlatlng: '',
                circlelatlng: '',
                flashing: false,
                leadhub_auth_token: '',
                record_count: 0,
                property_value_icon: 0,
                property_value_1: 0,
                property_value_2: 0,
                property_value_3: 2,
                property_value_2_hidden: '',
                property_value_3_hidden: 'hidden',
                property_values_dialog: false,
                selected_property_values: [],
                multiple_values_hidden: 'hidden',
                on_market_days_icon: 0,
                on_market_days_1: 0,
                on_market_days_2: 0,
                on_market_days_3: 2,
                on_market_days_2_hidden: '',
                on_market_days_3_hidden: 'hidden',
                on_market_days_dialog: false,
                selected_on_market_days: [],
                multiple_days_hidden: 'hidden',
                property_type_icon: 0,
                property_type: 0,
                property_types_dialog: false,
                selected_property_types: [],
                multiple_property_type_hidden: 'hidden',
                multiple_property_type_class: '',
                display_status_dialog: false,
                // selected_display_status: ['For Sale', 'Under offer', 'Sold STC', 'Sold STCM', 'Reserved', 'Let Agreed'],
                // selected_display_status_dialog: ['For Sale', 'Under offer', 'Sold STC', 'Sold STCM', 'Reserved', 'Let Agreed'],
                selected_display_status: ['Sold STC','Available','Withdrawn','Let Agreed','Under Offer','Reserved'],
                selected_display_status_dialog: ['Sold STC','Available','Withdrawn','Let Agreed','Under Offer','Reserved'],
                map_colours: [
                    '#0000ff',
                    '#00ff00',
                    '#ff0000',
                    '#ff00ff',
                    '#00ffff',
                    '#000000',
                    '#cccc00',
                    '#00aa00',
                    '#aa0000',
                    '#aa00aa',
                    '#00aaaa',
                    '#666666',
                    '#006600',
                    '#660000',
                    '#660066',
                    '#006666'
                ],
                items: [
                    'more than',
                    'less than',
                    'only',
                ],
                radius_choices_location: [],
                radius_choices_radius: [],
                // radius_choices_km: [{
                //     'text': '25m',
                //     'value': '0.025'
                // }, {
                //     'text': '50m',
                //     'value': '0.05'
                // }, {
                //     'text': '100m',
                //     'value': '0.1'
                // }, {
                //     'text': '150m',
                //     'value': '0.15'
                // }, {
                //     'text': '200m',
                //     'value': '0.2'
                // }, {
                //     'text': '0.25km',
                //     'value': '0.25'
                // }, {
                //     'text': '0.5km',
                //     'value': '0.5'
                // }, {
                //     'text': '1km',
                //     'value': '1'
                // }, {
                //     'text': '1.5km',
                //     'value': '1.5'
                // }, {
                //     'text': '2km',
                //     'value': '2'
                // }, {
                //     'text': '3km',
                //     'value': '3'
                // }, {
                //     'text': '5km',
                //     'value': '5'
                // }, {
                //     'text': '7.5km',
                //     'value': '7.5'
                // }, {
                //     'text': '10km',
                //     'value': '10'
                // }],
                radius_choices_km: [{
                    'text': '1km',
                    'value': '1'
                }, {
                    'text': '2km',
                    'value': '2'
                }, {
                    'text': '3km',
                    'value': '3'
                }, {
                    'text': '4km',
                    'value': '4'
                }, {
                    'text': '5km',
                    'value': '5'
                }, {
                    'text': '6km',
                    'value': '6'
                }, {
                    'text': '7km',
                    'value': '7'
                }, {
                    'text': '8km',
                    'value': '8'
                }, {
                    'text': '9km',
                    'value': '9'
                }, {
                    'text': '10km',
                    'value': '10'
                }, {
                    'text': '11km',
                    'value': '11'
                }, {
                    'text': '12km',
                    'value': '12'
                }, {
                    'text': '13km',
                    'value': '13'
                }, {
                    'text': '14km',
                    'value': '14'
                }, {
                    'text': '15km',
                    'value': '15'
                }],
                radius_choices_miles: [{
                    'text': '25m',
                    'value': '0.025'
                }, {
                    'text': '50m',
                    'value': '0.05'
                }, {
                    'text': '100m',
                    'value': '0.1'
                }, {
                    'text': '150m',
                    'value': '0.15'
                }, {
                    'text': '200m',
                    'value': '0.2'
                }, {
                    'text': '0.25mi',
                    'value': '0.402336'
                }, {
                    'text': '0.5mi',
                    'value': '0.804672'
                }, {
                    'text': '1mi',
                    'value': '1.609344'
                }, {
                    'text': '1.5mi',
                    'value': '2.414016'
                }, {
                    'text': '2mi',
                    'value': '3.218688'
                }, {
                    'text': '3mi',
                    'value': '4.828032'
                }, {
                    'text': '5mi',
                    'value': '8.04672'
                }, {
                    'text': '7.5mi',
                    'value': '12.07008'
                }, {
                    'text': '10mi',
                    'value': '16.09344'
                }],
                // radius_metres: {
                //     '0.025': [25],
                //     '0.050': [50],
                //     '0.1': [100],
                //     '0.15': [150],
                //     '0.2': [200],
                //     '0.25': [250],
                //     '0.5': [500],
                //     '1': [1000],
                //     '1.5': [1500],
                //     '2': [2000],
                //     '3': [3000],
                //     '5': [5000],
                //     '7.5': [7500],
                //     '10': [10000]
                // },
                radius_metres: {
                    '1': [1000],
                    '2': [2000],
                    '3': [3000],
                    '4': [4000],
                    '5': [5000],
                    '6': [6000],
                    '7': [7000],
                    '8': [8000],
                    '9': [9000],
                    '10': [10000],
                    '11': [11000],
                    '12': [12000],
                    '13': [13000],
                    '14': [14000],
                    '15': [15000]
                },
                icon_choices: [
                    'mdi-plus',
                    'mdi-minus'
                ],
                property_value_1_choices: [
                    'more than',
                    'less than',
                    'between'
                ],
                property_value_2_choices: [
                    '100k',
                    '150k',
                    '250k',
                    '500k',
                    '750k',
                    '1m',
                    '2m'
                ],
                property_value_3_choices: [
                    '100k',
                    '150k',
                    '250k',
                    '500k',
                    '750k',
                    '1m',
                    '2m'
                ],
                on_market_days_1_choices: [
                    'more than',
                    'less than',
                    'between'
                ],
                on_market_days_2_choices: [
                    '15 days',
                    '1 month',
                    '2 months',
                    '3 months',
                    '6 months',
                    '1 year',
                    '2 years'
                ],
                on_market_days_3_choices: [
                    '15 days',
                    '1 month',
                    '2 months',
                    '3 months',
                    '6 months',
                    '1 year',
                    '2 years'
                ],
                property_type_choices: [
                    'Detached house',
                    'Flat or maisonette',
                    'Semi-detached house',
                    'Terraced house',
                    'Other',
                    'multiple'
                ],
                switchable_opts: {
                    'more than': {
                        '100k': ['100000'],
                        '150k': ['150000'],
                        '250k': ['250000'],
                        '500k': ['500000'],
                        '750k': ['750000'],
                        '1m': ['1000000'],
                        '2m': ['2000000'],
                        '15 days': ['15'],
                        '1 month': ['30'],
                        '2 months': ['60'],
                        '3 months': ['90'],
                        '6 months': ['180'],
                        '1 year': ['360'],
                        '2 years': ['720']
                    },
                    'less than': {
                        '100k': ['100000'],
                        '150k': ['150000'],
                        '250k': ['250000'],
                        '500k': ['500000'],
                        '750k': ['750000'],
                        '1m': ['1000000'],
                        '2m': ['2000000'],
                        '15 days': ['15'],
                        '1 month': ['30'],
                        '2 months': ['60'],
                        '3 months': ['90'],
                        '6 months': ['180'],
                        '1 year': ['360'],
                        '2 years': ['720']
                    },
                    'between': {
                        '100k-150k': ['100000','150000'],
                        '100k-250k': ['100000','250000'],
                        '100k-500k': ['100000','500000'],
                        '100k-750k': ['100000','750000'],
                        '100k-1m': ['100000','1000000'],
                        '100k-2m': ['100000','2000000'],
                        '150k-250k': ['150000','250000'],
                        '150k-500k': ['150000','500000'],
                        '150k-750k': ['150000','750000'],
                        '150k-1m': ['150000','1000000'],
                        '150k-2m': ['150000','2000000'],
                        '250k-500k': ['250000','500000'],
                        '250k-750k': ['250000','750000'],
                        '250k-1m': ['250000','1000000'],
                        '250k-2m': ['250000','2000000'],
                        '500k-750k': ['500000','750000'],
                        '500k-1m': ['500000','1000000'],
                        '500k-2m': ['500000','2000000'],
                        '750k-1m': ['750000','1000000'],
                        '750k-2m+': ['750000','2000000'],
                        '1m-2m': ['1000000','2000000'],
                        '2m-2m': ['2000000','2000000'],
                        '15 days-1 month': ['15','30'],
                        '15 days-2 months': ['15','60'],
                        '15 days-3 months': ['15','90'],
                        '15 days-6 months': ['15','180'],
                        '15 days-1 year': ['15','360'],
                        '15 days-2 years': ['15','720'],
                        '1 month-2 months': ['30','60'],
                        '1 month-3 months': ['30','90'],
                        '1 month-6 months': ['30','180'],
                        '1 month-1 year': ['30','360'],
                        '1 month-2 years': ['30','720'],
                        '2 months-3 months': ['60','90'],
                        '2 months-6 months': ['60','180'],
                        '2 months-1 year': ['60','360'],
                        '2 months-2 years': ['60','720'],
                        '3 months-6 months': ['90','180'],
                        '3 months-1 year': ['90','360'],
                        '3 months-2 years+': ['90','720'],
                        '6 months-1 year': ['180','360'],
                        '6 months-2 years': ['180','720'],
                        '1 year-2 years': ['360','720'],
                        '2 years-2 years': ['720','720']
                    },
                    'property_value_1': [
                        'more than',
                        'less than',
                        'between'
                    ],
                    'property_value_2': {
                        '100k': '100000',
                        '150k': '150000',
                        '250k': '250000',
                        '500k': '500000',
                        '750k': '750000',
                        '1m': '1000000',
                        '2m': '2000000'
                    },
                    'property_value_3': {
                        '100k': '100000',
                        '150k': '150000',
                        '250k': '250000',
                        '500k': '500000',
                        '750k': '750000',
                        '1m': '1000000',
                        '2m': '2000000'
                    },
                    'on_market_days_1': [
                        'more than',
                        'less than',
                        'between'
                    ],
                    'on_market_days_2': {
                        '15 days': '15',
                        '1 month': '30',
                        '2 months': '60',
                        '3 months': '90',
                        '6 months': '180',
                        '1 year': '360',
                        '2 years': '720'
                    },
                    'on_market_days_3_': {
                        '15 days': '15',
                        '1 month': '30',
                        '2 months': '60',
                        '3 months': '90',
                        '6 months': '180',
                        '1 year': '360',
                        '2 years': '720'
                    },
                    'property_type': {
                        'Detached house': ['Detached'],
                        'Flat or maisonette': ['Flats'],
                        'Semi-detached house': ['Semi-Detached'],
                        'Terraced house': ['Terraced'],
                        'Other': ['Other'],
                        'multiple': ['multiple']
                    },
                    'display_status': {
                        'Sold STC': ['Sold+STC'],
                        'Available': ['Available'],
                        'Withdrawn':['Withdrawn'],
                        'Let Agreed': ['Let+Agreed'],
                        'Under Offer': ['Under+Offer'],
                        'Reserved': ['Reserved']
                    }
                },
                property_type_choices: [
                    'Detached house',
                    'Flat or maisonette',
                    'Semi-detached house',
                    'Terraced house',
                    'Other',
                    'multiple'
                ],
                display_status_choices: [
                    'Sold STC',
                    'Available',
                    'Withdrawn',
                    'Let Agreed',
                    'Under Offer',
                    'Reserved'
                ]
            };
        },
        components: {
        },
        mixins: [axios],
        watch: {
            center: function (val) {
                console.log('center=' + JSON.stringify(val));
            },
            tabs: function (val) {
                console.log('tabs=' + val);

                console.log('this.location=' + JSON.stringify(this.location));
                console.log('this.radius=' + JSON.stringify(this.radius));

                if (val == 0) {
                    this.tab_selected = 'location';
                    this.circles = this.location.circles;
                } else if (val == 1) {
                    this.tab_selected = 'radius';
                    this.circles = this.radius.circles;
                }

                var callLeadhub = false;

                console.log('this.tab_selected=' + this.tab_selected);
                console.log('this.circles.length=' + this.circles.length);

                if (this.tab_selected == 'location' && this.circles.length > 0) {
                    callLeadhub = true;
                    console.log('1');
                }

                if (this.tab_selected == 'radius' && this.circles.length > 0) {
                    callLeadhub = true;
                    console.log('2');
                }

                console.log('callLeadhub=' + callLeadhub);
                if (callLeadhub) {
                    this.callLeadhub();
                } else {
                    this.markers_array = [];
                    this.record_count = 0;

                    this.flashing = true;
                    setTimeout(() => this.flashing = false, 200);
                }
            }
        },
        computed: {
            google: gmapApi,
            add_pin_class() {
                return {
                    'btn-disabled': this.add_pin_disabled,
                    'btn-enabled': !this.add_pin_disabled,
                }
            },
            add_circle_class() {
                return {
                    'btn-disabled': this.add_circle_disabled,
                    'btn-enabled': !this.add_circle_disabled,
                }
            },
            pin_drawing_class() {
                return {
                    'hidden': this.addingPin == false ? true : false,
                }
            },
            circle_drawing_class() {
                return {
                    'hidden': this.addingCircle == false ? true : false,
                }
            },
            markers_drawing_class() {
                return {
                    'hidden': this.addingMarkers == false ? true : false,
                }
            },
            pinlatlng_class() {
                return {
                    'hidden': this.pinlatlng == '' ? true : false,
                }
            },
            circlelatlng_class_1() {
                return {
                    'hidden': !this.circle1_selected,
                }
            },
            circlelatlng_class_2() {
                return {
                    'hidden': !this.circle2_selected,
                }
            },
            preview_data_classes() {
                return {
                    'btn-disabled': this.record_count == 0 ? true : false,
                }
            },
            property_value_classes_1() {
                return {
                    'btn-disabled': this.property_value_icon == 0 ? true : false,
                    'btn-enabled': this.property_value_icon == 1 ? true : false,
                }
            },
            property_value_classes_2() {
                return {
                    'hidden': this.property_value_1_choices[this.property_value_1] != 'between' ? true : false,
                }
            },
            property_value_classes_3() {
                return {
                    'btn-disabled': this.property_value_icon == 0 ? true : false,
                    'btn-enabled': this.property_value_icon == 1 ? true : false,
                    'hidden': this.property_value_1_choices[this.property_value_1] != 'between' ? true : false,
                }
            },
            on_market_days_classes_1() {
                return {
                    'btn-disabled': this.on_market_days_icon == 0 ? true : false,
                    'btn-enabled': this.on_market_days_icon == 1 ? true : false,
                }
            },
            on_market_days_classes_2() {
                return {
                    'hidden': this.on_market_days_1_choices[this.on_market_days_1] != 'between' ? true : false,
                }
            },
            on_market_days_classes_3() {
                return {
                    'btn-disabled': this.on_market_days_icon == 0 ? true : false,
                    'btn-enabled': this.on_market_days_icon == 1 ? true : false,
                    'hidden': this.on_market_days_1_choices[this.on_market_days_1] != 'between' ? true : false,
                }
            },
            property_type_classes_1() {
                return {
                    'btn-disabled': this.property_type_icon == 0 ? true : false,
                    'btn-enabled': this.property_type_icon == 1 ? true : false,
                    'multiple-property_type': this.property_type_choices[this.property_type] == 'multiple' ? true : false,
                }
            },
            property_type_classes_2() {
                return {
                    'btn-disabled': this.property_type_icon == 0 ? true : false,
                    'btn-enabled': this.property_type_icon == 1 ? true : false,
                    'hidden': this.property_type_choices[this.property_type] != 'multiple' ? true : false,
                }
            },
            display_status_class() {
                return {
                    'hidden': !this.display_status_dialog,
                }
            },
            selected_display_status_text() {
                var selected = '';

                for (var i = 0; i < this.selected_display_status.length; i++) {
                    if (i > 0) {
                        selected += '<br />';
                    }
                    selected += '<i aria-hidden="true" class="v-icon notranslate mdi mdi-check theme--dark" style="font-size: 16px; color: black;"></i> ' + this.selected_display_status[i];
                }

                return selected;
            },
            selected_display_status_param() {
                var selected_filters = '';

                for (var i = 0; i < this.selected_display_status.length; i++) {
                    if (i > 0) {
                        selected_filters += ',';
                    }
                    selected_filters += this.switchable_opts.display_status[this.selected_display_status[i]][0];
                }

                return selected_filters;
            }
        },
        created() {
        },
        mounted() {
            parent.postMessage('ScrollIntoView', '*');

            if (window.sessionStorage.getItem('_radius_units_location') == null) {
                window.sessionStorage.setItem('_radius_units_location', 'km');
            }
            if (window.sessionStorage.getItem('_radius_units_radius') == null) {
                window.sessionStorage.setItem('_radius_units_radius', 'km');
            }

            if (window.sessionStorage.getItem('_radius_value_location') == null) {
                window.sessionStorage.setItem('_radius_value_location', '5');
            }
            if (window.sessionStorage.getItem('_radius_value_radius') == null) {
                window.sessionStorage.setItem('_radius_value_radius', '5');
            }

            if (window.sessionStorage.getItem('_display_status') == null) {
                window.sessionStorage.setItem('_display_status', this.selected_display_status_param);
            }

            window.sessionStorage.removeItem('imageUrl');

            this.radius_choices_location = this.radius_choices_km;
            this.radius_choices_radius = this.radius_choices_km;

            const getOrderById = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');
            console.log(getOrderById)

            Axios.get(getOrderById, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response.data);

                    var lat = 0,
                        lng = 0;

                    this.order = response.data[0];
                    console.log('this.order.dataUrl=' + this.order.dataUrl);

                    if (this.order.dataUrl == null) {
                        this.geolocate();
                    } else {
                        if (window.sessionStorage.getItem('_currentPlace') !== "undefined") {
                            this.tab_selected = window.sessionStorage.getItem('_searchType');
                            this.currentPlace = window.sessionStorage.getItem('_currentPlace');
                            //this.location = JSON.parse(window.sessionStorage.getItem('_location'));
                            //this.radius = JSON.parse(window.sessionStorage.getItem('_radius'));

                            console.log('_location_circles=' + JSON.parse(window.sessionStorage.getItem('_location_circles')));
                            console.log('_radius_circles=' + JSON.parse(window.sessionStorage.getItem('_radius_circles')));

                            if (window.sessionStorage.getItem('_location_circles') != null) {
                                this.location.circles = JSON.parse(window.sessionStorage.getItem('_location_circles'));
                            } else {
                                this.location.circles = [];
                            }

                            if (window.sessionStorage.getItem('_radius_circles') != null) {
                                this.radius.circles = JSON.parse(window.sessionStorage.getItem('_radius_circles'));
                            } else {
                                this.radius.circles = [];
                            }

                            if (this.tab_selected == 'location') {
                                this.tabs = 0;
                            } else if (this.tab_selected == 'radius') {
                                this.tabs = 1;
                            }
                        }

                        var dataUrl = decodeURIComponent(this.order.dataUrl);
                        console.log('dataUrl=' + dataUrl);

                        var qs = dataUrl,
                            params = qs.split('&');

                        for (var ip = 0; ip < params.length; ip++) {
                            console.log('params[' + ip + ']=' + params[ip]);

                            var param = params[ip].split('=');

                            console.log('param[0]=' + param[0]);

                            if (param[0] == 'lat') {
                                lat = parseFloat(param[1]);
                            }

                            if (param[0] == 'lng') {
                                lng = parseFloat(param[1]);
                            }

                            if (param[0] == 'radius') {
                                console.log('radius=' + param[1]);

                                if (this.tab_selected == 'location') {
                                    this.location.radius = param[1];
                                } else if (this.tab_selected == 'radius') {
                                    this.radius.radius = param[1];
                                }

                                if (this.currentPlace == '') {
                                    this.addingCircle = true;
                                }
                            }

                            if (param[0] == 'display_status') {
                                console.log('display_status=' + param[1]);

                                this.selected_display_status = [];

                                var display_statuses = param[1].split(',');

                                for (var i = 0; i < display_statuses.length; i++) {
                                    this.selected_display_status.push(display_statuses[i].replace('+', ' '));
                                }
                            }

                            if (param[0] == 'property_value_selected') {
                                this.property_value_icon = 1;

                                var property_value_params = param[1].split('||');

                                console.log('property_value_params[0]=' + property_value_params[0]);

                                if (property_value_params[0] == 'more than') {
                                    this.property_value_1 = 0;

                                    var obj = this.switchable_opts.property_value_2,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == property_value_params[1]) {
                                                this.property_value_2 = val;
                                            }
                                        }
                                        val++;
                                    }

                                } else if (property_value_params[0] == 'less than') {
                                    this.property_value_1 = 1;

                                    var obj = this.switchable_opts.property_value_2,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == property_value_params[1]) {
                                                this.property_value_2 = val;
                                            }
                                        }
                                        val++;
                                    }

                                } else if (property_value_params[0] == 'between') {
                                    this.property_value_1 = 2;

                                    var obj = this.switchable_opts.property_value_2,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == property_value_params[1]) {
                                                this.property_value_2 = val;
                                            }
                                        }
                                        val++;
                                    }

                                    var val = this.switchable_opts.property_value_2,
                                        val = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == property_value_params[2]) {
                                                this.property_value_3 = val;
                                            }
                                        }
                                        val++;
                                    }
                                }
                            }

                            if (param[0] == 'on_market_days_selected') {
                                this.on_market_days_icon = 1;

                                var on_market_days_params = param[1].split('||');

                                console.log('on_market_days_params[0]=' + on_market_days_params[0]);

                                if (on_market_days_params[0] == 'more than') {
                                    this.on_market_days_1 = 0;

                                    var obj = this.switchable_opts.on_market_days_2,
                                        days = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == on_market_days_params[1]) {
                                                this.on_market_days_2 = days;
                                            }
                                        }
                                        days++;
                                    }

                                } else if (on_market_days_params[0] == 'less than') {
                                    this.on_market_days_1 = 1;

                                    var obj = this.switchable_opts.on_market_days_2,
                                        days = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == on_market_days_params[1]) {
                                                this.on_market_days_2 = days;
                                            }
                                        }
                                        days++;
                                    }

                                } else if (on_market_days_params[0] == 'between') {
                                    this.on_market_days_1 = 2;

                                    var obj = this.switchable_opts.on_market_days_2,
                                        days = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == on_market_days_params[1]) {
                                                this.on_market_days_2 = days;
                                            }
                                        }
                                        days++;
                                    }

                                    var obj = this.switchable_opts.on_market_days_2,
                                        days = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == on_market_days_params[2]) {
                                                this.on_market_days_3 = days;
                                            }
                                        }
                                        days++;
                                    }
                                }
                            }

                            if (param[0] == 'property_types_selected') {
                                this.property_type_icon = 1;

                                var property_type_params = param[1].split('||');

                                console.log('property_type_params[0]=' + property_type_params[0]);
                                console.log('property_type_params[1]=' + property_type_params[1]);

                                if (property_type_params[0] == 'only') {
                                    this.property_type = 5; //multiple

                                    var property_type_params_only = property_type_params[1].split(',');

                                    for (var it = 0; it < property_type_params_only.length; it++) {
                                        this.selected_property_types.push(property_type_params_only[it]);
                                    }

                                } else {
                                    var obj = this.switchable_opts.property_type,
                                        type = 0;
                                    for (var p in obj) {
                                        if (obj.hasOwnProperty(p)) {
                                            if (p == property_type_params[1]) {
                                                this.property_type = type;
                                            }
                                        }
                                        type++;
                                    }
                                }
                            }
                        }

                        if (lat !== 0 && lng !== 0) {
                            console.log('lat=' + lat);
                            console.log('lng=' + lng);

                            this.center = {
                                lat: lat,
                                lng: lng
                            };
                        }

                        console.log('this.currentPlace=' + this.currentPlace);
                        console.log('this.addingPin=' + this.addingPin);
                        console.log('this.addingCircle=' + this.addingCircle);

                        //if (this.currentPlace !== '') {
                        if (this.tab_selected == 'location') {
                            this.location.center = this.center;
                            //this.radius.distance = Number(this.radius_metres[this.radius.radius]);
                            this.location.distance = Number(this.location.radius);
                            this.distance = this.location.distance * 1000;

                            console.log('radius.radius: ' + this.radius.radius.value);
                            console.log('distance: ' + this.distance);

                            this.area_colour = this.getShapeColour(0);
                            console.log('area_colour: ' + this.area_colour);

                            //this.circles.push({position: this.center, distance: this.location.radius});
                            //this.circles.push({position: this.center});

                            this.location.circles = [];
                            this.location.circles.push({position: this.center});
                            this.circles = this.location.circles;

                            window.sessionStorage.setItem('_location_circles', JSON.stringify(this.location.circles));

                            //this.circlelatlng = 'Radius 1 (' + (this.distance / 1000).toFixed(4) + ' km)';
                            //this.circle1_selected = true;
                            //this.circle2_selected = false;

                            var radius_value = window.sessionStorage.getItem('_radius_value_location'),
                                radius_units = window.sessionStorage.getItem('_radius_units_location');


                            this.location.distance_unit = radius_units;

                            if (this.location.distance_unit === 'km') {
                                this.radius_choices_location = this.radius_choices_km;
                            } else {
                                this.radius_choices_location = this.radius_choices_miles;
                            }

                            this.setRadius(radius_value);

                        } else {
                            //if (this.addingPin == true) {
                            //    console.log('this.center.lat=' + this.center.lat);
                            //    console.log('this.center.lng=' + this.center.lng);
                            //    console.log('this.center.lat (4 dec)=' + this.center.lat.toFixed(4));
                            //    console.log('this.center.lng (4 dec)=' + this.center.lng.toFixed(4));

                            //    this.pins.push({position: this.center});
                            //    this.pinlatlng = 'Pin 1 (' + this.center.lat.toFixed(4) + ',' + this.center.lng.toFixed(4) + ')';
                            //    this.addingPin = false;
                            //    this.markers_array = [];
                            //}

                            //if (this.addingCircle == true) {
                                this.radius.center = this.center;
                                //this.radius.distance = Number(this.radius_metres[this.radius.radius]);
                                this.radius.distance = Number(this.radius.radius);
                                this.distance = this.radius.distance * 1000;

                                console.log('radius.radius: ' + this.radius.radius.value);
                                console.log('distance: ' + this.distance);

                                ++this.radius_count;

                                //this.area_colour = this.getShapeColour(this.radius_count - 1);
                                this.area_colour = this.getShapeColour(0);
                                console.log('area_colour: ' + this.area_colour);

                                this.circles = this.radius.circles;

                                var radius_value = window.sessionStorage.getItem('_radius_value_radius'),
                                    radius_units = window.sessionStorage.getItem('_radius_units_radius');

                                this.radius.distance_unit = radius_units;

                                if (this.radius.distance_unit === 'km') {
                                    this.radius_choices_radius = this.radius_choices_km;
                                } else {
                                    this.radius_choices_radius = this.radius_choices_miles;
                                }

                                this.setRadius(radius_value);

                                //this.circlelatlng = 'Radius 1 (' + (this.distance / 1000).toFixed(4) + ' km)';
                                this.addingCircle = false;
                            //}
                        }

                        this.callLeadhub();
                    }
                });
        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            change() {
                console.log(this.currentPlace);

                if (this.currentPlace == '') {
                    this.add_pin_disabled = false;
                }
            },
            // receives a place object via the autocomplete component
            setPlace(place) {
                console.log(place)
                this.currentPlace = place;
            },
            addPin() {
                if (event.currentTarget.classList.contains('btn-disabled')) {
                    return;
                }

                if (this.radius.radius !== '') {
                    console.log('adding circle');
                    this.removeCircle();
                    this.addingCircle = true;
                }
            },
            removePin() {
                console.log('removing pin');

                this.pins.splice(0, 1);
                this.pinlatlng = '';
                this.record_count = 0;
                this.markers_array = [];

                window.sessionStorage.removeItem('qs');
            },
            addCircleToMap() {
                if (event.currentTarget.classList.contains('btn-disabled')) {
                    return;
                }

                console.log('adding radius');

                this.addingCircle = true;
            },
            removeCircle() {
                console.log('removing circle');

                if (this.tab_selected == 'location') {
                    //this.location.circles.splice(0, 1);
                    this.location.circles = [];
                    this.circles = this.location.circles;
                    this.circle1_selected = false;
                } else {
                    //this.radius.circles.splice(0, 1);
                    this.radius.circles = [];
                    this.circles = this.radius.circles;
                    this.circle2_selected = false;
                }

                //this.circles.splice(0, 1);
                this.circlelatlng = '';
                this.record_count = 0;
                this.markers_array = [];

                --this.radius_count;
                if (this.radius_count < 0) {
                    this.radius_count == 0;
                }

                window.sessionStorage.removeItem('qs');
            },
            saveDisplayStatusChoices() {
                console.log('saveDisplayStatusChoices');

                this.selected_display_status = this.selected_display_status_dialog;
                window.sessionStorage.setItem('_display_status', this.selected_display_status_param);

                this.display_status_dialog = false;
                this.markers_array = [];
                this.callLeadhub();
            },
            closeDisplayStatusChoices() {
                this.selected_display_status_dialog = this.selected_display_status;
                this.display_status_dialog = false;
            },
            applyFilters() {
                console.log('applying filters');
                console.log('this.record_count=' + this.record_count);

                this.markers_array = [];
                this.callLeadhub();
            },
            addPinToMap() {
                console.log('adding marker');

                console.log('this.pins=' + this.pins);
                console.log('this.places=' + this.places);
                console.log('this.center=' + this.center);

                console.log('this.pinlatlng=' + this.pinlatlng);
                console.log('this.circlelatlng=' + this.circlelatlng);
                console.log('this.currentPlace=' + this.currentPlace);

                if (this.circlelatlng != '') {
                    this.markers_array = [];

                    this.callLeadhub();
                    return false;
                }

                if (this.currentPlace == '') {
                    this.dialog = true;
                    return false;
                }

                console.log('this.currentPlace=' + this.currentPlace);
            },
            addCircleToMapFromText() {
                console.log('currentPlace=' + this.currentPlace);
                console.log('location.radius=' + JSON.stringify(this.location.radius));

                if (this.tab_selected == 'location') {
                    if (this.currentPlace === '') {
                        this.dialog = true;
                        return false;
                    }
                }

                if (this.location.radius === '') {
                    this.dialog = true;
                    return false;
                }

                this.removeCircle();

                let geocoder = new this.google.maps.Geocoder();
                let address = this.currentPlace;

                geocoder.geocode({'address': address}, (results, status) => {

                    console.log('status=' + status);

                    if (status == google.maps.GeocoderStatus.OK) {
                        this.markers = [];
                        this.places = [];
                        this.markers_array = [];

                        console.log('lat=' + results[0].geometry.location.lat());
                        console.log('lng=' + results[0].geometry.location.lng());

                        this.location.center = {
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng()
                        };
                        this.center = this.location.center;

                        console.log('location.radius: ' + JSON.stringify(this.location.radius));

                        //this.location.distance = Number(this.radius_metres[this.location.radius]);
                        this.location.distance = Number(this.location.radius.value);
                        this.distance = this.location.distance * 1000;

                        console.log('distance: ' + this.distance);

                        ++this.radius_count;

                        //this.area_colour = this.getShapeColour(this.radius_count - 1);
                        this.area_colour = this.getShapeColour(0);
                        console.log('area_colour: ' + this.area_colour);

                        //this.circles.push({position: this.center, distance: this.location.radius});
                        this.circles.push({position: this.center});

                        //this.circlelatlng = 'Radius 1 (' + (this.distance / 1000).toFixed(4) + ' km)';
                        //this.circle1_selected = true;
                        //this.circle2_selected = false;

                        var radius_value = window.sessionStorage.getItem('_radius_value_location'),
                            radius_units = window.sessionStorage.getItem('_radius_units_location');

                        this.location.distance_unit = radius_units;

                        if (this.location.distance_unit === 'km') {
                            this.radius_choices_location = this.radius_choices_km;
                        } else {
                            this.radius_choices_location = this.radius_choices_miles;
                        }

                        this.setRadius(radius_value);

                        this.callLeadhub();
                        this.add_circle_disabled = true;
                    }
                });       
            },
            geolocate() {
                navigator.geolocation.getCurrentPosition(position => {
                    console.log('Your current position is:');
                    console.log(`Latitude : ${position.coords.latitude}`);
                    console.log(`Longitude: ${position.coords.longitude}`);
                    console.log(`More or less ${position.coords.accuracy} meters.`);
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                }, err => {
                    console.log('error in getCurrentPosition');
                    console.log(err.message);

                    if (window.sessionStorage.getItem('templatingValues') !== "undefined") {
                        var templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));

                        console.log('templatingValues.varUser_PostCode=' + templatingValues.varUser_PostCode);

                        this.$gmapApiPromiseLazy().then(() => {
                            let geocoder = new this.google.maps.Geocoder();
                            let address = templatingValues.varUser_PostCode;

                            geocoder.geocode({'address': address}, (results, status) => {
                                console.log('status=' + status);

                                if (status == google.maps.GeocoderStatus.OK) {
                                    console.log('lat=' + results[0].geometry.location.lat());
                                    console.log('lng=' + results[0].geometry.location.lng());

                                    this.center = {
                                        lat: results[0].geometry.location.lat(),
                                        lng: results[0].geometry.location.lng()
                                    };
                                } else {
                                    this.center = {
                                        lat: 51.5049,
                                        lng: -0.0786
                                    };
                                }
                            });
                        })
                    } else {
                        this.center = {
                            lat: 51.5049,
                            lng: -0.0786
                        };
                    }
                })
            },
            getLocation(place) {
                console.log('getLocation');
                console.log('this.tab_selected=' + this.tab_selected);
                console.log('this.radius.circles.length=' + this.radius.circles.length);

                if (this.tab_selected == 'radius' && this.radius.circles.length == 0) {
                    console.log('on:click ', place);

                    if (this.radius.radius === '') {
                        this.dialog = true;
                        this.addingCircle = false;
                        return false;
                    }

                    //this.radius.distance = Number(this.radius_metres[this.radius.radius]);
                    this.radius.distance = Number(this.radius.radius.value);
                    this.distance = this.radius.distance * 1000;

                    console.log('radius.radius: ' + JSON.stringify(this.radius.radius));
                    console.log('distance: ' + this.distance);
                    console.log('place.latLng: ' + place.latLng);

                    ++this.radius_count;

                    //this.area_colour = this.getShapeColour(this.radius_count - 1);
                    this.area_colour = this.getShapeColour(0);
                    console.log('area_colour: ' + this.area_colour);

                    this.radius.center = {
                        lat: place.latLng.lat(),
                        lng: place.latLng.lng()
                    };
                    this.center = this.radius.center;

                    this.radius.circles.push({position: this.center});
                    this.circles = this.radius.circles;

                    window.sessionStorage.setItem('_radius_circles', JSON.stringify(this.radius.circles));

                    //this.circlelatlng = 'Radius 1 (' + (this.distance / 1000).toFixed(4) + ' km)';
                    //this.circle1_selected = false;
                    //this.circle2_selected = true;
                    this.addingCircle = false;

                    //window.sessionStorage.setItem('_searchType', 'location');
                    //window.sessionStorage.setItem('_currentPlace', '');
                    //window.sessionStorage.setItem('_location', '');
                    //window.sessionStorage.setItem('_radius', '');

                    this.callLeadhub();
                }
            },
            getShapeColour(count) {
                console.log('getShapeColour count: ' + count);

                if (count > this.map_colours.length) {
                    var division = Math.round(count / this.map_colours.length),
                        count = count - (this.map_colours.length * division);

                    if (count < 0) {
                        count = 0;
                    }
                }
                return this.map_colours[count];
            },
            getAddressParam(property) {
                var addressParam = '';

                if (property.addr1 != '') {
                    addressParam += property.addr1 + ' ';
                }
                if (property.addr2 != '') {
                    addressParam += property.addr2 + ' ';
                }
                if (property.addr3 != '') {
                    addressParam += property.addr3 + ' ';
                }
                if (property.addr4 != '') {
                    addressParam += property.addr4 + ' ';
                }
                if (property.addr5 != '') {
                    addressParam += property.addr5 + ' ';
                }
                if (property.addr6 != '') {
                    addressParam += property.addr6 + ' ';
                }
                if (property.postcode != '') {
                    addressParam += property.postcode + ' ';
                }

                addressParam = addressParam.substring(0, addressParam.length - 1).replace(/ /g, '%20');

                return addressParam;
            },
            callLeadhub() {
                //console.log('this.circlelatlng=' + this.circlelatlng);

                /*if (this.circlelatlng == '') {
                    this.dialog = true;
                    return false;
                }*/

                if (this.tab_selected == 'location') {
                    if (this.currentPlace === '') {
                        this.dialog = true;
                        return false;
                    }
                }

                if (this.tab_selected == 'location') {
                    if (this.radius.radius === '') {
                        this.dialog = true;
                        return false;
                    }
                }

                var selected_filters = '',
                    operator,
                    range;

                if (this.property_value_icon > 0) {
                    console.log('property value filter applied');

                    operator = this.property_value_1_choices[this.property_value_1];
                    switch (operator) {
                        case 'more than':
                            range = this.property_value_2_choices[this.property_value_2];
                            selected_filters += '&min_price=' + this.switchable_opts[operator][range][0];
                            selected_filters += '&property_value_selected=' + operator + '||' + this.property_value_2_choices[this.property_value_2];

                            break;
                        case 'less than':
                            range = this.property_value_2_choices[this.property_value_2];
                            selected_filters += '&max_price=' + this.switchable_opts[operator][range][0];
                            selected_filters += '&property_value_selected=' + operator + '||' + this.property_value_2_choices[this.property_value_2];

                            break;
                        case 'between':
                            range = this.property_value_2_choices[this.property_value_2] + '-' + this.property_value_3_choices[this.property_value_3];

                            selected_filters += '&min_price=' + this.switchable_opts[operator][range][0];
                            selected_filters += '&max_price=' + this.switchable_opts[operator][range][1];
                            selected_filters += '&property_value_selected=' + operator + '||' + this.property_value_2_choices[this.property_value_2] + '||' + this.property_value_3_choices[this.property_value_3];

                            break;
                    }
                }

                if (this.on_market_days_icon > 0) {
                    console.log('days on market filter applied');

                    operator = this.on_market_days_1_choices[this.on_market_days_1];
                    switch (operator) {
                        case 'more than':
                            range = this.on_market_days_2_choices[this.on_market_days_2];
                            selected_filters += '&min_days_on_market=' + this.switchable_opts[operator][range][0];
                            selected_filters += '&on_market_days_selected=' + operator + '||' + this.on_market_days_2_choices[this.on_market_days_2];

                            break;
                        case 'less than':
                            range = this.on_market_days_2_choices[this.on_market_days_2];
                            selected_filters += '&max_days_on_market=' + this.switchable_opts[operator][range][0];
                            selected_filters += '&on_market_days_selected=' + operator + '||' + this.on_market_days_2_choices[this.on_market_days_2];

                            break;
                        case 'between':
                            range = this.on_market_days_2_choices[this.on_market_days_2] + '-' + this.on_market_days_3_choices[this.on_market_days_3];

                            selected_filters += '&min_days_on_market=' + this.switchable_opts[operator][range][0];
                            selected_filters += '&max_days_on_market=' + this.switchable_opts[operator][range][1];
                            selected_filters += '&on_market_days_selected=' + operator + '||' + this.on_market_days_2_choices[this.on_market_days_2] + '||' + this.on_market_days_3_choices[this.on_market_days_3];

                            break;
                    }
                }

                if (this.property_type_icon > 0) {
                    console.log('property type filter applied');

                    var property_type_choice = this.property_type_choices[this.property_type];

                    if (property_type_choice == 'multiple') {
                        var selected = 'only||';

                        selected_filters += '&property_types=';

                        for (var i = 0; i < this.selected_property_types.length; i++) {
                            if (i > 0) {
                                selected_filters += ',';
                                selected += ',';
                            }
                            selected_filters += this.switchable_opts.property_type[this.selected_property_types[i]];
                            selected += this.selected_property_types[i];
                        }

                        selected_filters += '&property_types_selected=' + selected + '||';
                    } else {
                        selected_filters += '&property_types=' + this.switchable_opts.property_type[property_type_choice];

                        selected_filters += '&property_types_selected=' + '||' + property_type_choice + '||';
                    }
                }

                console.log('selected_filters=' + selected_filters);

                this.loading = true;

                if (this.tab_selected == 'location') {
                    this.center = this.location.center;
                    this.distance = this.location.distance * 1000;
                    this.circle1_selected = true;
                } else {
                    this.center = this.radius.center;
                    this.distance = this.radius.distance * 1000;
                    this.circle2_selected = true;
                }

                console.log('this.center.lat: ' + this.center.lat);
                console.log('this.center.lng: ' + this.center.lng);

                //this.query_string = '/api/v1/properties?lat=' + this.center.lat + '&lng=' + this.center.lng + '&radius=' + (this.distance / 1000) + selected_filters;
                this.query_string = 'lat=' + this.center.lat + '&lng=' + this.center.lng + '&radius=' + (this.distance / 1000) + '&display_status=' + this.selected_display_status_param + selected_filters + '&expanded=false';
                //this.data_url = `${process.env.VUE_APP_TKGATEWAY}` + this.query_string;
                //this.data_url = leadhubApiUrl + this.query_string;
                this.data_url = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=SpectreSearch&code=zpg1&customerRef=RAV02`;
                this.dataProvider = 'Leadhub';

                console.log('this.query_string: ' + this.query_string);
                console.log('this.data_url: ' + this.data_url);

                Axios({
                    method: 'post',
                    url: this.data_url,
                    crossdomain: true,
                    data: this.query_string,
                    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                })
                    .then(response => {
                        console.log('search success');
                        console.log(response.data);

                        var markerOptions = {
                            url: 'https://rpsassets.blob.core.windows.net/rpsimages/images/icons/home-address.png',
                            size: {width: 60, height: 60, f: 'px', b: 'px',},
                            scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
                            anchor: new google.maps.Point(15, 30),
                        };

                        for (var item, i = 0; item = response.data.attributes[i++];) {
                            this.markers_array.push({position: {lat: item.attributes.lat, lng: item.attributes.lng}, markerOptions: markerOptions});
                        }

                        //console.log(this.markers_array);

                        this.record_count = response.data.attributes.length;

                        this.flashing = true;
                        setTimeout(() => this.flashing = false, 200);

                        // window.sessionStorage.setItem('qs', qs);
                        // window.sessionStorage.setItem('dataProvider', 'Leadhub');
                        // window.sessionStorage.setItem('_leadhub_data_auth_token', leadhub_data_token);

                        window.sessionStorage.setItem('_searchType', this.tab_selected);
                        window.sessionStorage.setItem('_currentPlace', this.currentPlace);
                        //window.sessionStorage.setItem('_location', JSON.stringify(this.location));
                        //window.sessionStorage.setItem('_radius', JSON.stringify(this.radius));

                        this.loading = false;
                    })
                    .catch(error => {
                        if (error.response) {
                            //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            console.log('search failure: ' + JSON.stringify(error.response));
                        }

                        this.loading = false;
                    })
            },
            previewData() {
                if (event.currentTarget.classList.contains('btn-disabled')) {
                    return;
                }

                if (this.record_count == 0) {
                    return;
                }

                //Check if the order id exists and create order if not
                if (window.sessionStorage.getItem('_order_id') !== "undefined") {
                    this.loading = true;

                    const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

                    const update_body = [
                        {
                            "value": this.query_string,
                            "path": "/dataUrl",
                            "op": "replace",
                            "from": "string"
                        },
                        {
                            "value": this.dataProvider,
                            "path": "/dataProvider",
                            "op": "replace",
                            "from": "string"
                        }
                    ]

                    Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log(response.data);

                            window.sessionStorage.setItem('_leadhub_auth_token', this.leadhub_auth_token);

                            this.loading = false;
                            this.navigate('data-preview');
                        })
                        .catch(error => {
                            if (error.response) {
                                //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                                console.log('data order patch failure: ' + JSON.stringify(error.response));
                            }

                            this.loading = false;
                        });
                }
            },
            clickPropertyValueIcon() {
                if (this.property_value_icon == this.icon_choices.length - 1) {
                    this.property_value_icon = 0;
                } else {
                    this.property_value_icon++;
                }
            },
            clickPropertyValue1() {
                if (this.property_value_icon > 0) {
                    if (this.property_value_1_choices[this.property_value_1] == 'between') {
                        this.clickPropertyValue3();
                    }

                    if (this.property_value_1 == this.property_value_1_choices.length - 1) {
                        this.property_value_1 = 0;
                    } else {
                        this.property_value_1++;
                    }
                }
            },
            clickPropertyValue2() {
                if (this.property_value_icon > 0) {
                    if (this.property_value_2 == this.property_value_2_choices.length - 1) {
                        this.property_value_2 = 0;
                    } else {
                        this.property_value_2++;
                    }

                    if (this.property_value_1_choices[this.property_value_1] == 'between') {
                        this.property_value_3 = this.property_value_2 + 1;
                    }
                }
            },
            clickPropertyValue3() {
                if (this.property_value_icon > 0) {
                    if (this.property_value_3 == this.property_value_3_choices.length - 1) {
                        this.property_value_3 = 0;
                    } else {
                        this.property_value_3++;
                    }
                }
            },
            clickOnMarketDaysIcon() {
                if (this.on_market_days_icon == this.icon_choices.length - 1) {
                    this.on_market_days_icon = 0;
                } else {
                    this.on_market_days_icon++;
                }
            },
            clickOnMarketDays1() {
                if (this.on_market_days_icon > 0) {
                    if (this.on_market_days_1_choices[this.on_market_days_1] == 'between') {
                        this.clickOnMarketDays3();
                    }

                    if (this.on_market_days_1 == this.on_market_days_1_choices.length - 1) {
                        this.on_market_days_1 = 0;
                    } else {
                        this.on_market_days_1++;
                    }
                }
            },
            clickOnMarketDays2() {
                if (this.on_market_days_icon > 0) {
                    if (this.on_market_days_2 == this.on_market_days_2_choices.length - 1) {
                        this.on_market_days_2 = 0;
                    } else {
                        this.on_market_days_2++;
                    }

                    if (this.on_market_days_1_choices[this.on_market_days_1] == 'between') {
                        this.on_market_days_3 = this.on_market_days_2 + 1;
                    }
                }
            },
            clickOnMarketDays3() {
                if (this.on_market_days_icon > 0) {
                    if (this.on_market_days_3 == this.on_market_days_3_choices.length - 1) {
                        this.on_market_days_3 = 0;
                    } else {
                        this.on_market_days_3++;
                    }
                }
            },
            clickPropertyTypeIcon() {
                if (this.property_type_icon == this.icon_choices.length - 1) {
                    this.property_type_icon = 0;
                } else {
                    this.property_type_icon++;
                }
            },
            clickPropertyType() {
                if (this.property_type_icon > 0) {
                    if (this.property_type == this.property_type_choices.length - 1) {
                        this.property_type = 0;
                    } else {
                        this.property_type++;
                    }
                }
            },
            clickDisplayStatus() {
                console.log('clickDisplayStatus');

                if (this.display_status_dialog) {
                    this.display_status_dialog = false;
                } else {
                    this.display_status_dialog = true;
                }
            },
            pinDragged(index, location) {
                console.log('updateCoordinates');
                console.log('lat=' + location.lat());
                console.log('lng=' + location.lng());

                this.center = {
                    lat: location.lat(),
                    lng: location.lng()
                };

                console.log('this.center.lat=' + this.center.lat);
                console.log('this.center.lng=' + this.center.lng);
                console.log('this.center.lat (4 dec)=' + this.center.lat.toFixed(4));
                console.log('this.center.lng (4 dec)=' + this.center.lng.toFixed(4));

                this.pinlatlng = 'Pin 1 (' + this.center.lat.toFixed(4) + ',' + this.center.lng.toFixed(4) + ')';
                this.markers_array = [];
            },
            radiusChanged(radius) {
                console.log('radiusChanged');
                console.log('radius=' + radius);
                console.log('this.distance=' + this.distance);

                if (this.distance == radius) {
                    return false;
                }

                // Limit radius to 10000 (10 km)
                if (radius > 10000) {
                    console.log('Radius capped at 10km');

                    this.maximumRadiusMessage = true;
                    radius = 10000;

                    this.$refs.circle[0].$circlePromise.then(() => {
                        const {$circleObject} = this.$refs.circle[0]; //get google.maps.Circle object
                        $circleObject.setRadius(radius);
                    })
                }

                var new_radius = Math.floor(radius / 1000) * 1000;
                if (new_radius == 0) {
                    new_radius = 1000;
                }

                if (radius != new_radius) {
                    radius = new_radius;
                    this.$refs.circle[0].$circlePromise.then(() => {
                        const {$circleObject} = this.$refs.circle[0]; //get google.maps.Circle object
                        $circleObject.setRadius(radius);
                    })
                }

                this.distance = radius / 1000;

                if (this.tab_selected == 'location') {
                    this.location.distance = this.distance;
                } else if (this.tab_selected == 'radius') {
                    this.radius.distance = this.distance;
                }

                //this.circlelatlng = 'Radius 1 (' + (this.distance / 1000).toFixed(4) + ' km)';

                this.markers_array = [];
                this.callLeadhub();
            },
            centerChanged(center) {
                console.log('centerChanged');
                console.log('center.lat=' + center.lat());
                console.log('center.lng=' + center.lng());
                console.log('this.center.lat=' + this.center.lat);
                console.log('this.center.lng=' + this.center.lng);

                if (this.center.lat == center.lat() && this.center.lng == center.lng()) {
                    return false;
                }

                this.center = {
                    lat: center.lat(),
                    lng: center.lng()
                };

                if (this.tab_selected == 'location') {
                    this.location.center = this.center;
                } else if (this.tab_selected == 'radius') {
                    this.radius.center = this.center;
                }

                //this.circles.splice(0, 1);
                if (this.tab_selected == 'location') {
                    this.location.circles = [];
                    this.location.circles.push({position: this.center, distance: this.location.radius.value});
                    this.circles = this.location.circles;
                } else if (this.tab_selected == 'radius') {
                    this.radius.circles = [];
                    this.radius.circles.push({position: this.center, distance: this.radius.radius.value});
                    this.circles = this.radius.circles;
                }

                this.markers_array = [];
                this.callLeadhub();
            },
            radiusSelected() {
                console.log('radiusSelected');

                if (this.tab_selected == 'location') {
                    this.setRadius(this.location.radius);

                    window.sessionStorage.setItem('_radius_value_location', this.location.radius.value);

                } else if (this.tab_selected == 'radius') {
                    this.setRadius(this.radius.radius);

                    window.sessionStorage.setItem('_radius_value_radius', this.radius.radius.value);

                }
            },
            setRadius(radius) {
                console.log('setRadius');
                console.log('radius=' + radius);

                var selected_text,
                    selected_value;

                if (this.tab_selected == 'location') {
                    if (this.location.distance_unit === 'km') {
                        for (var i = 0; i < this.radius_choices_km.length; i++)
                        {
                            if (this.radius_choices_km[i].value == radius)
                            {
                                selected_text = this.radius_choices_km[i].text;
                                selected_value = this.radius_choices_km[i].value;
                            }
                        }
                    } else {
                        for (var i = 0; i < this.radius_choices_miles.length; i++)
                        {
                            if (this.radius_choices_miles[i].value == radius)
                            {
                                selected_text = this.radius_choices_miles[i].text;
                                selected_value = this.radius_choices_miles[i].value;
                            }
                        }
                    }

                    this.location.radius = { 'text': selected_text, 'value': selected_value };

                    console.log(JSON.stringify(this.location.radius));

                } else if (this.tab_selected == 'radius') {
                    if (this.radius.distance_unit === 'km') {
                        for (var i = 0; i < this.radius_choices_km.length; i++)
                        {
                            if (this.radius_choices_km[i].value == radius)
                            {
                                selected_text = this.radius_choices_km[i].text;
                                selected_value = this.radius_choices_km[i].value;
                            }
                        }
                    } else {
                        for (var i = 0; i < this.radius_choices_miles.length; i++)
                        {
                            if (this.radius_choices_miles[i].value == radius)
                            {
                                selected_text = this.radius_choices_miles[i].text;
                                selected_value = this.radius_choices_miles[i].value;
                            }
                        }
                    }

                    this.radius.radius = { 'text': selected_text, 'value': selected_value };

                    console.log(JSON.stringify(this.radius.radius));
                }
            },            
            clickDistanceUnit() {
                //TEMPORARY! - DO NOT ALLOW UNITS TO BE CHANGED - THEY MUST STAY AT KM FOR NOW.
                return;

                if (this.tab_selected == 'location') {
                    console.log('search=' + (this.location.radius.text.search(/km|mi/)));

                    if (this.location.distance_unit === 'km') {
                        this.location.distance_unit = 'miles';
                        this.radius_choices_location = this.radius_choices_miles;

                        var new_value;
                        if (this.location.radius.text.search(/km|mi/) > 0){
                            new_value = this.toMetres(this.location.radius.value, 'mi', false);
                        } else {
                            new_value = this.location.radius.value
                        }

                        this.location.radius = { 'text': this.location.radius.text, 'value': new_value.toString() };

                        console.log('this.location.radius(mi)=' + JSON.stringify(this.location.radius));
                    } else {
                        this.location.distance_unit = 'km';
                        this.radius_choices_location = this.radius_choices_km;

                        var new_value;
                        if (this.location.radius.text.search(/km|mi/) > 0){
                            new_value = this.metresTo(this.location.radius.value, 'mi', false);
                        } else {
                            new_value = this.location.radius.value
                        }

                        this.location.radius = { 'text': this.location.radius.text, 'value': new_value.toString() };

                        console.log('this.location.radius(km)=' + JSON.stringify(this.location.radius));
                    }

                    window.sessionStorage.setItem('_radius_units_location', this.location.distance_unit);
                    window.sessionStorage.setItem('_radius_value_location', this.location.radius.value);

                } else if (this.tab_selected == 'radius') {
                    console.log('search=' + (this.radius.radius.text.search(/km|mi/)));

                    if (this.radius.distance_unit === 'km') {
                        this.radius.distance_unit = 'miles';
                        this.radius_choices_radius = this.radius_choices_miles;

                        var new_value;
                        if (this.radius.radius.text.search(/km|mi/) > 0){
                            new_value = this.toMetres(this.radius.radius.value, 'mi', false);
                        } else {
                            new_value = this.radius.radius.value
                        }

                        this.radius.radius = { 'text': this.radius.radius.text, 'value': new_value.toString() };

                        console.log('this.radius.radius(mi)=' + JSON.stringify(this.radius.radius));
                    } else {
                        this.radius.distance_unit = 'km';
                        this.radius_choices_radius = this.radius_choices_km;

                        var new_value;
                        if (this.radius.radius.text.search(/km|mi/) > 0){
                            new_value = this.metresTo(this.radius.radius.value, 'mi', false);
                        } else {
                            new_value = this.radius.radius.value
                        }

                        this.radius.radius = { 'text': this.radius.radius.text, 'value': new_value.toString() };

                        console.log('this.radius.radius(km)=' + JSON.stringify(this.radius.radius));
                    }

                    window.sessionStorage.setItem('_radius_units_radius', this.radius.distance_unit);
                    window.sessionStorage.setItem('_radius_value_radius', this.radius.radius.value);
                }
            },
            metresTo(value, unit, display_unit) {
                var string = '';
                switch (unit) {
                    case 'mi':
                        //string = value / 1609.344;
                        string = value / 1.609344;
                    break;
                    default:
                        //km
                        //string = value / 1000;
                        string = value;
                    break;
                }

                if (display_unit === true) {
                    string = string.toFixed(3) + ' ' + unit;
                }

                return string;
            },
            toMetres(value, unit, display_unit) {
                var string = '';
                switch (unit) {
                    case 'mi':
                        //string = value * 1609.344;
                        string = value * 1.609344;
                    break;
                    default:
                        //km
                        //string = value * 1000;
                        string = value;
                    break;
                }

                if (display_unit === true) {
                    string = string.toFixed(3) + ' ' + unit;
                }

                return string;
            }
        }
    };
</script>